import React from 'react';
import Tippy from '@tippy.js/react';
import styles from './ToolTip.module.css';

const ToolTip = (props) => {
  return (
    <Tippy
      zIndex={999}
      placement="top"
      distance={8}
      animation="fade"
      duration={0}
      trigger="click"
      flipOnUpdate={!!props.isAccordion}
      content={props.content}
      enabled={props.enabled}
      className={`${styles.toolTip} ${
        props.viewSize && !props.isAccordion ? styles[props.viewSize] : ''
      }`}
    >
      {props.children}
    </Tippy>
  );
};

export default ToolTip;
